export const LEVEL_STYLES = {
  "3e": { bg: "bg-sky-100", text: "text-sky-700", dot: "bg-sky-500", label: "3e primaire" },
  "4e": { bg: "bg-amber-100", text: "text-amber-700", dot: "bg-amber-500", label: "4e primaire" },
  "5e": { bg: "bg-rose-100", text: "text-rose-700", dot: "bg-rose-500", label: "5e primaire" },
  "6e": { bg: "bg-emerald-100", text: "text-emerald-700", dot: "bg-emerald-500", label: "6e primaire" },
};

export const LEVELS = ["3e", "4e", "5e", "6e"];

export const ACTIVITIES_START = "2026-10-05";

export const PERIODS = [
  { value: "matin", label: "Matin (8h-12h)", short: "Matin" },
  { value: "apres_midi", label: "Après-midi (13h-16h)", short: "Après-midi" },
];

export const PERIOD_LABELS = { matin: "Matin (8h-12h)", apres_midi: "Après-midi (13h-16h)" };

export const COMPETENCES = [
  "Information & données",
  "Communication",
  "Création de contenus",
  "Sécurité",
  "Citoyenneté numérique",
];

export function levelStyle(level) {
  return LEVEL_STYLES[level] || LEVEL_STYLES["3e"];
}
